<template>
  <div :class="['container container-header']">
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="header-input-container form-group" v-if="currentIndexTheme > 0">
        <div :class="componentStyle.header + '-header'">
          <h3 :class="[componentStyle.header + '-subtitle', 'text-left']">
            {{ currentTheme.title }}
          </h3>
          <span v-if="nbVideosByTheme > 0" :class="componentStyle.header + '-nbVideos'">{{
            nbVideosByTheme + ' Vidéos'
          }}</span>
        </div>
        <span :class="[componentStyle.header + '-description', 'text-left']">{{
          currentTheme.description
        }}</span>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import SearchBar from '~/node_modules/search-bar/src/components/Component.vue';
import ListItems from '~/node_modules/list-items/src/components/Component.vue';
import Mixin from '@/mixins/Mixin';
import HeaderInfo from './HeaderInfo';

import HasPermission from '../directives/HasPermission.js';
export default {
  name: 'HeaderInfo',
  components: {
    SearchBar,
    ListItems,
    HeaderInfo,
  },
  mixins: [Mixin],
  data() {
    return {
      updateCurrentTheme: false,
    };
  },
  computed: {
    ...mapGetters({
      componentStyle: 'layout/getComponentStyle',
      currentTheme: 'themes/getCurrentTheme',
      currentIndexTheme: 'videos/getCurrentTheme',
      nbVideos: 'videos/getNbVideos',
      nbVideosByTheme: 'themes/getNbVideosByTheme',
    }),
  },
  methods: {
    ...mapActions('themes', ['setCurrentThemeDetails']),
  },
  created() {},
  mounted() {
  },
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/HeaderInfo.vue